export const shouldFetchMlThemesFallback = (
  evidencesReady: boolean | undefined,
  evidenceIdsCount: number,
  dbSubThemesCount: number,
): boolean =>
  dbSubThemesCount === 0
  && evidencesReady === true
  && evidenceIdsCount > 0;

export const buildThemesBatchImpactKey = (
  themes: { id?: string; title?: string; evidenceIds?: string[] }[]
): string =>
  themes
    .map((theme) => `${theme.id || theme.title || ''}:${(theme.evidenceIds || []).slice().sort().join('|')}`)
    .join(';');
